var BASEURL = 'https://api-v2.happay.in/';
var ASSETS_BASE_URL = 'https://assets.happay.in/';
export default BASEURL;
export { ASSETS_BASE_URL };
